import React, { useCallback, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import styles from './Form.module.scss';

/* global APP_CONFIG */

function Form({ children, data = { marketingCrew: true }, onSubmit, hideRecaptcha }) {
  const captcha = useRef(null);
  const [isLoading, setLoading] = useState(false);
  const [formData, setFormData] = useState(data);

  const send = useCallback((recaptchaResponse) => {
    fetch( APP_CONFIG.endPoint, { 
        method: "POST", 
        body: new URLSearchParams({
          ...formData,
          competitionId: APP_CONFIG.competitionId,
          recaptchaResponse
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
    })
    .then(response => response.json())
    .then(data => {
        setLoading( false );
        onSubmit( formData, data );
    });
  },[formData, onSubmit]);

  async function handleSubmit(e){
    e.preventDefault(); 

    setLoading(true);

    if( !APP_CONFIG.disableRecaptcha ) {
      window.grecaptcha.reset();
      const token = await captcha.current.executeAsync();
      send( token );
    } else {
      send( null );
    }
  }

  function handleChange(event) {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;

      setFormData({
        ...formData,
        [name]: value
      });
  }

  return (
    <form className={[styles.form, hideRecaptcha ? styles.hideRecaptcha : ''].join(' ')} onChange={handleChange} onSubmit={handleSubmit}>
      {children}

      {!APP_CONFIG.disableRecaptcha &&
        <ReCAPTCHA ref={captcha} sitekey={ APP_CONFIG.recapchaKey } size="invisible" />
      }
    </form>
  );
}

function FormRow({ children, ...other }) {
  return (
      <div className={styles.formRow} {...other}>
          {children}
      </div>
  );
}

function FormAction({ children, ...other }) {
  return (
      <div className={styles.formAction} {...other}>
          {children}
      </div>
  );
}

export { Form as default, FormRow, FormAction };